import { createFileRoute } from "@tanstack/react-router";

import { QuickbooksFormPage } from "~/pages/connection-new/quickbooks-form.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection/quickbooks",
)({
  component: QuickbooksFormPage,
});
